<template>
  <div>
    <div class="t-hs-list">
      <transition name="fade">
        <div
          v-if="!scrollStart && !$forSize['phone-only']"
          @click="scroll('left')"
          class="left-arrow"
        />
      </transition>

      <transition name="fade">
        <div
          v-if="!scrollEnd && !$forSize['phone-only']"
          @click="scroll('right')"
          class="right-arrow"
        />
      </transition>

      <div ref="list" :class="this.getListConteinerClass" @scroll="handleScroll">
        <div
          :key="item.id"
          v-for="(item) in items"
          class="item"
        >
          <div class="item-name" v-html="item.nome" v-bind:title="item.nome" />
          <img class="item-image" :src="item.imagem" @click="(event) => handleClick(event, item)" />
          <a class="item-button" @click="(event) => handleClick(event, item)">Ver detalhes</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 't-hs-list',
  props: {
    items: Array,
    noScroll: Boolean,
    noSpaceBefore: Boolean
  },
  data () {
    return {
      cardInitialPosition: 0,
      scrollLeft: 0,
      scrollLeftMax: 0,
      activeCard: null
    }
  },
  computed: {
    images () {
      return Object.assign(
        {},
        this.items.map((item) => item.imagem)
      )
    },
    scrollStart () {
      return this.scrollLeft < 75
    },
    scrollEnd () {
      return this.scrollLeft >= this.scrollLeftMax - 175
    },
    getListConteinerClass () {
      const { noScroll, noSpaceBefore } = this.$props
      return `hs${noScroll ? ' no-scroll' : ''}${noSpaceBefore ? ' no-space-before' : ''}`
    }
  },
  methods: {
    handleClick (event, item) {
      Array.from(document.getElementsByClassName('active')).forEach(
        (element) => {
          element.classList.remove('active')
        }
      )
      this.activeCard = event.target.closest('.item')
      const rect = this.activeCard.getBoundingClientRect()
      const { x, width } = rect
      const isRightOverflow = x + width + 15 > window.innerWidth
      const isLeftOverflow = x - 15 < 0
      this.cardInitialPosition = x
      if (isRightOverflow) {
        this.scroll('right')
        if (!this.$forSize['phone-only']) return
      } else if (isLeftOverflow) {
        this.scroll('left')
        if (!this.$forSize['phone-only']) return
      }
      this.activeCard.classList.add('active')
      this.$emit('click', this.activeCard, item)
    },
    scroll (direction) {
      const list = this.$refs.list
      let x =
        direction === 'right'
          ? window.innerWidth - 400
          : -window.innerWidth + 400
      list.scrollBy({
        left: x,
        behavior: 'smooth'
      })
    },
    deactiveCard (forced = false) {
      if (this.activeCard) {
        const hs = this.$el.querySelectorAll('.hs')[0]
        const scrollDistance = Math.abs(
          this.cardInitialPosition - this.activeCard.getBoundingClientRect().x
        )
        if (forced || scrollDistance > 128) {
          Array.from(hs.children).forEach((child) => {
            child.classList.remove('active')
            this.activeCard = null
          })
        }
      }
    },
    handleScroll () {
      const hs = this.$el.querySelectorAll('.hs')[0]
      this.scrollLeft = hs.scrollLeft
      this.scrollLeftMax = hs.scrollWidth - (hs.clientWidth - 150)
      this.deactiveCard()
    }
  },
  watch: {
    items: {
      handler (items) {
        this.$nextTick(() => {
          this.handleScroll()
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
$item-width: 200px;
$item-height: 315px;
$item-margin: 1500px;
$phone-only-item-width: 116px;
$phone-only-item-height: 154px;
$phone-only-item-margin: 5px;

.t-hs-list {
  display: flex;
  box-sizing: content-box;
  align-items: center;
  position: relative;

  .left-arrow,
  .right-arrow {
    z-index: 1;
    position: absolute;
    width: 75px;
    height: calc(100% - 8px);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    backdrop-filter: blur(5px);

    &:after {
      content: '';
      background-color: var(--secondary);
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: -1;
      opacity: 1;
      opacity: 0.75;
      border-radius: inherit;
    }

    &:before {
      content: '';
      height: 30px;
      width: 30px;
      z-index: 1;
      font-family: 'Material Icons';
      font-size: 36px;
      color: var(--on-secondary);
    }
  }
  .right-arrow {
    right: 0;
    border-radius: 15px 0 0 15px;

    &:before {
      content: 'chevron_right';
    }
  }
  .left-arrow {
    border-radius: 0 15px 15px 0;

    &:before {
      content: 'chevron_left';
    }
  }

  @include for-size(phone-only) {
    .left-arrow,
    .right-arrow {
      display: none;
    }
  }

  .hs {
    padding-bottom: 8px;
    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    overflow-x: scroll;
    overflow-y: visible;
    display: flex;
    scroll-padding: $item-width / 2 + $item-margin;

    @include for-size(phone-only) {
      scroll-padding: $phone-only-item-width / 2 + $phone-only-item-margin;
      padding: 10px 0 20px 0;
    }

    &.no-scroll {
      display: flex;
      flex-flow: row wrap;
      overflow: initial;
      scroll-snap-type: initial;
      scroll-padding: initial;
      min-height: auto;
      height: auto;
      max-height: auto;
    }

    .item {
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      align-items: center;
      background-color: var(--surface);
      transition: box-shadow 0.15s cubic-bezier(0.4, 0, 0.2, 1),
        transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      overflow: hidden;
      user-select: none;
      box-shadow: 0 3px 3px -2px rgb(0 0 0 / 20%), 0 3px 4px 0 rgb(0 0 0 / 14%), 0 1px 8px 0 rgb(0 0 0 / 12%);
      scroll-snap-align: start;
      margin: $phone-only-item-margin;
      min-width: $phone-only-item-width;
      max-width: $phone-only-item-width;
      min-height: $phone-only-item-height;
      padding: 6px;

      &.active {
        box-shadow: 1px 2px 16px 0 rgba(0, 0, 0, 0.25);
        transform: scale(1.05);
      }

      &-name {
        display: block;
        color: var(--on-surface);
        font-size: 14px;
        font-weight: 600;
        padding-bottom: 7.5px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        min-height: 15px;
      }

      &-image {
        height: auto;
        min-width: 25px;
        max-width: calc(100% - 6px);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        transition: opacity 500ms cubic-bezier(0, 0, 0.2, 1);
        cursor: pointer;
      }

      &-button {
        cursor: pointer;
        padding-top: 15px;
        text-align: center;
        width: auto;
        font-size: 14px !important;
        line-height: 14px;
        font-weight: 700;
        text-decoration: underline;
        color: var(--link);
        letter-spacing: 0.28px;
      }

      @include for-size(desktop-up) {
        margin: 0 15px;
        width: $item-width;
        min-width: $item-width;
        max-width: $item-width;
        min-height: $item-height;
        max-height: $item-height;
        padding: 15px;

        &-name {
          display: block;
          padding-bottom: 15px;
          color: black;
          font-size: 14px;
        }

        &-image {
          height: auto;
          min-width: 125px;
          max-width: calc(100% - 12.5px);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          transition: opacity 500ms cubic-bezier(0, 0, 0.2, 1);
        }

        &-button {
          font-size: 16px;
        }
      }
    }

    > *:first-child {
      margin-left: 3vw;

      @include for-size(phone-only) {
        margin-left: 8vw;
      }

      @include for-size(desktop-up) {
        margin-left: 10vw;
      }
    }

    &.no-space-before {
      justify-content: flex-start;
      width: 100%;
      position: relative;

      > * {
        margin-left: 5px;

        @include for-size(phone-only) {
          margin-left: 5px;
        }

        @include for-size(desktop-up) {
          margin-left: initial;
          margin-right: 25px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
